import { AnalyticsProgramTitle, NO_EPG_DATA } from '~/shared/constants'

// 'No Program Data' in UI -> 'No EPG data' in Analytics
export const convertToAnalyticsTitle = (title: string, isHourly: boolean) => {
  let programTitle = title
  if (isHourly) {
    programTitle = AnalyticsProgramTitle.HOURLY_CATCHUP
  } else if (programTitle === NO_EPG_DATA) {
    programTitle = AnalyticsProgramTitle.NO_EPG_DATA
  }

  return programTitle
}
